/** English text for the lower home page sections. Each value is also its translation key. */
export const H = {
  supported: 'Supported devices',
  haunts: "It haunts whatever screen you've got.",
  smartTv: 'Smart TVs',
  smartTvS: 'Samsung, LG, Android TV',
  fire: 'Fire TV Stick',
  fireS: 'All generations',
  boxes: 'Android Boxes',
  boxesS: 'NVIDIA Shield, MAG, Formuler',
  phones: 'Phones',
  phonesS: 'iPhone & Android',
  tablets: 'Tablets',
  tabletsS: 'iPad & Android tablets',
  computers: 'Computers',
  computersS: 'Windows, macOS, browser',

  testimonials: 'Testimonials from the afterlife',
  reviewsCount: '{count} reviews',
  leaveYours: 'Already a customer? Leave yours from your account once your line is live.',
  noTestimonials: 'No testimonials yet',
  firstReviews: 'The first reviews will appear here as soon as customers share them.',
  viewer: 'A Ghost Cable viewer',
  replied: 'Ghost Cable replied:',
  showMore: 'Show more reviews',
  loading: 'Loading…',

  whispers: 'Whispers from the other side',
  q1: 'How does ordering work?',
  a1: "Create your account, choose a plan and send the order request. That's the only automated step. We then email you an invoice with payment instructions for your chosen method by hand. Once we've confirmed your payment, we send your login details and setup guide, and they also appear in your account. This is usually done within a few hours.",
  q2: 'Why are payments handled manually?',
  a2: "No payment is taken on this website and no card details are stored here. Every payment is collected and confirmed by a person on our team, then your line is activated by hand. That's why there's a short wait between ordering, paying and going live.",
  q3: 'Can I get a refund?',
  a3: "No. Our plans and Desktop Telly licences are digital products, so all sales are final once paid. If anything isn't working, open a support ticket from your account and we'll work through it with you until it's fixed. Not sure it'll work on your device? Ask for a free trial when you order a plan. Full details are on our No-refund policy page.",
  q4: 'Which currency will I pay in?',
  a4: 'All prices are set and invoiced in US dollars. Use the currency picker above the plans to see approximate prices in your own currency. Our team keeps the exchange rates up to date, so the converted amount can move slightly over time.',
  q5: 'What is Desktop Telly?',
  a5: 'Desktop Telly is a player app for Windows, macOS, Linux, Android and Apple TV. We sell lifetime licences for $7 each: pay once, use each licence on one device at a time and move it to a new device whenever you like. Want it on several screens at once? Buy as many licences as you need (up to 10 per order). Buy it on its own or add it to any plan at checkout. Your licence key appears in your account once payment is confirmed.',
  q6: 'What is a connection?',
  a6: 'A connection is one screen streaming at a time. The Demon plan lets you choose 1 to 5 simultaneous connections. The Wraith plan is a single connection.',
  q7: 'What content is on Ghost Cable?',
  a7: 'Ghost Cable carries our own original channels and on-demand programming, created and programmed by Ghost Cable.',
  q8: 'Which payment methods do you accept?',
  a8: "Credit card, Wise, crypto and Interac e-Transfer (CAD only). Choose your preferred method when you order and we'll send matching instructions.",
  q9: 'Does it auto-renew?',
  a9: "No. Every term is a one-time payment. We'll email you before your term ends, and you can renew only if you want to.",
  q10: 'What do I need to get started?',
  a10: "A supported device, an IPTV player app (we'll recommend one) and a steady internet connection. We suggest 10 Mbps or more per connection for HD.",
  q11: 'Is there a Ghost Cable app?',
  a11: 'Yes. This website installs as an app on iPhone, iPad, Android, Windows, Mac and Chromebook, with no app store needed. It opens full screen from your home screen or desktop and keeps your orders, login details, renewals and tickets one tap away. It is your account app; you still watch in your IPTV player.',
  installLink: 'See how to install it',

  received: 'Message received from beyond.',
  replyTo: "We'll reply to {email} soon.",
  another: 'Send another message',
  help: 'How can we help?',
  msgPh: 'Please enter your message here…',
  name: 'Name',
  yourName: 'Your name',
  email: 'Email',
  send: 'Send message',
  sending: 'Sending…',

  welcome: 'Welcome back',
  haunted: 'Already haunted?',
  oneClick: 'Your line is one click away.',
  signInGC: 'Sign in to Ghost Cable.',
  lives: 'Orders, credentials, licence keys, receipts and support tickets live in your account.',
  keepTap: 'Keep it one tap away: install Ghost Cable as an app',
  console: 'Open the console',
  goAccount: 'Go to my account',
  create: 'Create an account',
};
